/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RevisdomAPIViewModelsUserResponse } from './RevisdomAPIViewModelsUserResponse';
import {
    RevisdomAPIViewModelsUserResponseFromJSON,
    RevisdomAPIViewModelsUserResponseFromJSONTyped,
    RevisdomAPIViewModelsUserResponseToJSON,
    RevisdomAPIViewModelsUserResponseToJSONTyped,
} from './RevisdomAPIViewModelsUserResponse';

/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsUserUserListResponse
 */
export interface RevisdomAPIViewModelsUserUserListResponse {
    /**
     * 
     * @type {Array<RevisdomAPIViewModelsUserResponse>}
     * @memberof RevisdomAPIViewModelsUserUserListResponse
     */
    users?: Array<RevisdomAPIViewModelsUserResponse> | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsUserUserListResponse interface.
 */
export function instanceOfRevisdomAPIViewModelsUserUserListResponse(value: object): value is RevisdomAPIViewModelsUserUserListResponse {
    return true;
}

export function RevisdomAPIViewModelsUserUserListResponseFromJSON(json: any): RevisdomAPIViewModelsUserUserListResponse {
    return RevisdomAPIViewModelsUserUserListResponseFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserUserListResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsUserUserListResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'users': json['users'] == null ? undefined : ((json['users'] as Array<any>).map(RevisdomAPIViewModelsUserResponseFromJSON)),
    };
}

export function RevisdomAPIViewModelsUserUserListResponseToJSON(json: any): RevisdomAPIViewModelsUserUserListResponse {
    return RevisdomAPIViewModelsUserUserListResponseToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsUserUserListResponseToJSONTyped(value?: RevisdomAPIViewModelsUserUserListResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'users': value['users'] == null ? undefined : ((value['users'] as Array<any>).map(RevisdomAPIViewModelsUserResponseToJSON)),
    };
}

